export default function FAQSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-sm font-label tracking-widest uppercase text-foreground-400 mb-4">
            Got Questions?
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {[
            {
              q: 'What is the Superbuy Spreadsheet?',
              a: 'The Superbuy Spreadsheet is a comprehensive, community-curated database of verified products available through Superbuy. It includes detailed product links, QC photos, seller ratings, and category-based organization covering shoes, clothing, accessories, and more.',
            },
            {
              q: 'How often is the spreadsheet updated?',
              a: 'Our Superbuy spreadsheet receives daily updates. New verified products are added, outdated listings removed, and seller ratings refreshed to ensure you always have access to the most current shopping information.',
            },
            {
              q: 'Are all products quality-checked?',
              a: 'Yes. Every product listed in our spreadsheet has been verified through actual purchase experience or peer-reviewed QC reports. We maintain a strict 99%+ quality approval rate.',
            },
            {
              q: 'How do I use the spreadsheet to find products?',
              a: 'Simply browse by category using the navigation menu or category buttons on this page. Each category links to the corresponding section on kaspreadsheet.com, where you will find organized product listings with all relevant details.',
            },
            {
              q: 'Which shipping method should I choose?',
              a: 'DHL offers the fastest delivery (5-10 days), EMS provides a good balance of speed and affordability (7-15 days), and economy lines work best for budget-conscious buyers (15-30 days). Our spreadsheet includes detailed shipping comparisons.',
            },
            {
              q: 'Is the Superbuy Spreadsheet free to access?',
              a: 'Absolutely. The Superbuy Spreadsheet is completely free. Our mission is to help the community find quality products efficiently. Browse the categories above and start discovering verified products today.',
            },
          ].map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                <span className="text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-lg text-foreground-400 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}